export default "__VITE_ASSET__Ck_Y4shv__"